export const ACCAUNT_METRIKA = { omoda: 90262136, jaecoo: 94486851 };

export const ALLOWED_GOALS = {
  waiting_call: {
    omoda: "credit_form_submit",
    jaecoo: "credit_form_submit",
  },
};
